import React from 'react'
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap'
import i18next from 'i18next'
import { Range, Map } from 'immutable'

import TranslationInput from './TranslationInput'
import GridContainer from './GridContainer'
import Button from './Button'

import adminStyles from './styles/admin.scss'

import translationsKeysForServer from '../assets/translations/translationKeysForServer'

export default class Translations extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      prefix: 'wopiQuestions',
      language: 'fi',
      translations: Map()
    }
  }

  componentDidMount() {
    this.props.onSelectTranslatableLanguage()
  }

  componentWillReceiveProps(props) {
    this.setState({
      translations: props.currentTranslations
    })
  }

  render() {
    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <header>
            <h1>{i18next.t('translations')}</h1>
          </header>

          <Row>
            <Col sm={12}>
              <FormGroup controlId="language">
                <Row>
                  <Col xs={5}>
                    <FormControl
                      name="language"
                      componentClass="select"
                      defaultValue="fi"
                      onChange={this.onChange.bind(this)}
                    >
                      <option value="fi">{i18next.t('finnish')}</option>
                      <option value="en">{i18next.t('english')}</option>
                      <option value="sv">{i18next.t('swedish')}</option>
                      <option value="ru">{i18next.t('russian')}</option>
                      <option value="de">{i18next.t('german')}</option>
                      <option value="et">{i18next.t('estonian')}</option>
                      <option value="lt">{i18next.t('lithuanian')}</option>
                      <option value="lv">{i18next.t('latvian')}</option>
                    </FormControl>
                  </Col>

                  <Col xs={4} sm={5}>
                    <FormControl
                      name="prefix"
                      componentClass="select"
                      defaultValue=""
                      onChange={this.onChange.bind(this)}
                    >
                      <option value="wopiQuestions">
                        {i18next.t('translations_for_wopiQuestions')}
                      </option>
                      <option value="wopiTest">{i18next.t('translations_for_wopiTest')}</option>
                      <option value="wopiProfile">
                        {i18next.t('translations_for_wopiProfile')}
                      </option>

                      <option value="wopi360Questions">
                        {i18next.t('translations_for_wopi360Questions')}
                      </option>
                      <option value="wopi360Test">
                        {i18next.t('translations_for_wopi360Test')}
                      </option>
                      <option value="wopi360Profile">
                        {i18next.t('translations_for_wopi360Profile')}
                      </option>

                      <option value="groupDriversProfile">
                        {i18next.t('translations_for_groupDriversProfile')}
                      </option>

                      <option value="groupRolesProfile">
                        {i18next.t('translations_for_groupRolesProfile')}
                      </option>

                      <option value="emails">{i18next.t('translations_for_emails')}</option>
                      <option value="ui">{i18next.t('translations_for_ui')}</option>
                    </FormControl>
                  </Col>

                  <Col xs={3} sm={2}>
                    <Button
                      text={i18next.t('select')}
                      onClick={this.onSelectTranslatableLanguage.bind(this)}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          </Row>

          {this.props.currentLanguage && (
            <Row>
              <Col sm={12}>
                {this.renderTranslationInputElements(
                  this.props.currentPrefix,
                  this.state.translations,
                  this.props.translationsInEnglish
                )}

                <div style={{ margin: '20px 0', textAlign: 'right' }}>
                  <Button text={i18next.t('save')} onClick={this.onSave.bind(this)} />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </GridContainer>
    )
  }

  renderTranslationInputElements(prefix, translations, translationsInEnglish) {
    if (prefix === 'wopiQuestions') {
      return (
        <div>
          <h3>{i18next.t('translations_for_wopiQuestions')}</h3>

          {Range(1, 225).map(questionIndex => (
            <TranslationInput
              translationKey={questionIndex}
              label={questionIndex + '.'}
              translation={translations[questionIndex]}
              onChange={this.onChangeQuestion.bind(this)}
              key={questionIndex}
              translationInEnglish={translationsInEnglish[questionIndex]}
            />
          ))}
        </div>
      )
    }

    if (prefix === 'wopi360Questions') {
      return (
        <div>
          <h3>{i18next.t('translations_for_wopi360Questions')}</h3>

          {Range(1, 51).map(questionIndex => (
            <TranslationInput
              translationKey={questionIndex}
              label={questionIndex + '.'}
              translation={translations[questionIndex]}
              onChange={this.onChangeQuestion.bind(this)}
              key={questionIndex}
              translationInEnglish={translationsInEnglish[questionIndex]}
            />
          ))}
        </div>
      )
    }

    return this.renderTranslationInputsForPrefix(prefix, translations, translationsInEnglish)
  }

  renderTranslationInputsForPrefix(prefix, translations, translationsInEnglish) {
    return (
      <div>
        <h3>{i18next.t('translations_for_' + prefix)}</h3>

        {translationsKeysForServer[prefix].map(key => (
          <TranslationInput
            translationKey={key}
            label={key}
            translation={translations[key]}
            onChange={this.onChangeQuestion.bind(this)}
            key={key}
            translationInEnglish={translationsInEnglish[key]}
          />
        ))}
      </div>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSelectTranslatableLanguage(e) {
    this.props.onSelectTranslatableLanguage(this.state.language, this.state.prefix)
  }

  onChangeQuestion(e) {
    const questions = this.state.translations
    questions[e.target.name] = e.target.value

    this.setState({ translations: questions })
  }

  onSave() {
    this.props.onUpdateTranslationsForLanguage(
      this.props.currentLanguage,
      this.props.currentPrefix,
      this.state.translations
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Translations.js